module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ilrCJ1/tc-custom/9781449406202.jpg?1707566367707",
      "alt": "This image is the cover for the book Women Are from Venus, Men Are Idiots"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Women Are from Venus, Men Are Idiots\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Inside "), _c('i', [_vm._v("Women Are from Venus, Men Are Idiots")]), _vm._v(", "), _c('i', [_vm._v("Close to Home")]), _vm._v(" cartoonist John McPherson illustrates what happens when planets--and planetary beings--just don't seem to align. From memorable Thanksgiving TV-carving dinners to disjointed marriage counseling sessions, McPherson culls more than 75 relationship-specific, full-color panels inside this interplanetary ode to coupledom.")]), _c('p', [_vm._v("McPherson's mastery in "), _c('i', [_vm._v("Close to Home")]), _vm._v(" is elevating the mundane to the magnificent. The caustic interactions between balding, bespeckled middle-aged men and auburn-haired, beehive-tressed women become achingly funny when sketched by his pen. Appearing in more than 700 newspapers internationally, McPherson's "), _c('i', [_vm._v("Close to Home")]), _vm._v(" is one of the most popular card lines from Recycled Paper Greetings. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John McPherson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0